export const RESEARCH_RUNS_PANEL_ID = "research-runs"
export const RESEARCH_RUNS_PANEL_WIDTH_PX = 360

type ResearchRunsPanelActionInput = {
  currentPanelId: string | null | undefined
  isContentSidebarOpen: boolean
}

export function getResearchRunsPanelAction({
  currentPanelId,
  isContentSidebarOpen,
}: ResearchRunsPanelActionInput): "open" | "close" {
  return isContentSidebarOpen && currentPanelId === RESEARCH_RUNS_PANEL_ID ? "close" : "open"
}
